import React from "react";
import { useTranslation } from "react-i18next";

const WaitingApproval: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900 p-4 sm:p-6 lg:p-8">
      <div className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-md border border-gray-100 dark:border-gray-700 w-full max-w-md text-center">
        <h2 className="text-2xl font-bold mb-6 text-gray-700 dark:text-gray-100">
          {t("waitingForApproval")}
        </h2>
        <p className="text-gray-600 dark:text-gray-400">{t("registrationPendingApproval")}</p>
      </div>
    </div>
  );
};

export default WaitingApproval;
